import { useAuth } from '@ab-core/hooks';

type BusinessUnitType = {
    [key: string]: string;
};

const getDivision: BusinessUnitType = {
    '1': 'SB',
    '2': 'SI',
    '4': 'SC'
};

export const getDivisionByBusinessUnit = (businessUnit?: string) => {
    if (!businessUnit || !getDivision[businessUnit]) {
        return undefined;
    }

    return getDivision[businessUnit];
};

export const useDivision = () => {
    const { user } = useAuth();

    return getDivisionByBusinessUnit(user?.activeAccount?.businessUnit);
};
